import { messages as ko } from "./ko";
import { messages as en } from "./en";

export default {
  ko,
  en
};
